import styled from 'styled-components';

const TimelineStyles = styled.section`
  padding: 4rem 0;

  .heading,
  .subheading {
    margin: 0;
    text-align: center;
  }

  .heading {
    margin: 0 0 0.5rem;
  }

  .subheading {
    color: var(--color-bark);
  }

  .events {
    position: relative;
    margin: 3rem 0 0;
    padding: 1.5rem 0 0 0;

    &::before {
      top: 0;
      left: 0;
      width: 0.2rem;
      height: 100%;
      border-left: 0.25rem dotted var(--color-bark);
    }

    &::before,
    .event::before,
    .event .block::after {
      content: '';
      position: absolute;
      display: block;
    }

    .event {
      position: relative;
      display: flex;
      padding: 0 0 3.125rem;

      &::before {
        top: 1.5rem;
        left: -0.3rem;
        width: 0.8rem;
        height: 0.8rem;
        background-color: var(--color-bark);
        border-radius: 100%;
      }

      .block {
        position: relative;
        margin: 0 0 0 2.5rem;
        padding: 3rem 1.5rem;
        flex-grow: 1;
        background-color: #fff;

        &::after {
          top: 1.6rem;
          left: -0.55rem;
          width: 0;
          height: 0;
          border-width: 0.4rem 0.6rem 0.4rem 0;
          border-color: transparent #fff transparent transparent;
          border-style: solid;
        }

        .date {
          margin: 0 0 0.5rem;
          font-size: 0.938rem;
          font-weight: var(--font-weight-regular);
          color: var(--color-bark);
        }
      }
    }
  }

  @media (min-width: 768px) {
    padding: 6rem 0;

    .events {
      margin: 5rem 0 0;
      padding: 3rem 0 0 0;

      &::before {
        left: 50%;
        transform: translateX(-50%);
      }

      .event {
        margin-top: -6rem;

        &::before {
          left: 50%;
          transform: translateX(-50%);
          width: 1.3rem;
          height: 1.3rem;
        }

        .block {
          flex-grow: 0;
          width: 45%;
          margin: 0;

          &::after {
            top: 1.8rem;
          }

          .date {
            font-size: 1.125rem;
          }
        }

        &:first-child {
          margin-top: 0;
        }

        &:nth-child(even) {
          .block {
            margin-left: auto;
          }
        }

        &:nth-child(odd) {
          .block {
            &::after {
              left: unset;
              right: -0.55rem;
              border-width: 0.4rem 0 0.4rem 0.6rem;
              border-color: transparent transparent transparent #fff;
            }
          }
        }
      }
    }
  }
`;

export default TimelineStyles;
